import { Circle } from "react-feather"

export default [
    {
        id: "lesson-option",
        title: "Хичээл сонголт",
        icon: <i className="fal fa-home"></i>,
        navLink: "/lesson/option/",
        children: [
            {
                id: 'base',
                title: ' Үндсэн сонголт',
                icon: <Circle size={8} />,
                navLink: "base/"
            },
            // {
            //     id: 'add',
            //     title: 'Нэмэлт сонголт',
            //     icon: <Circle size={8} />,
            //     navLink: "add/"
            // },
            {
                id: 're-exam',
                title: 'Дахин шалгалт',
                icon: <Circle size={8} />,
                navLink: "re-exam/"
            },
            {
                id: 'kr',
                title: 'Кр нөхөлт',
                icon: <Circle size={8} />,
                navLink: "kr/"
            },
        ]
    },
]